/** 
 * CR #423 
 * @Author Anupama P 
 * @Date 18/06/2021 
 */
const Menu = {
    HOME: {
        visible: false,
        subMenu: false
    },
    DOCTORS: {
        visible: false, /* Bug #456  @Author Akhil Mc  @Date 08/Aug/2021  */
        subMenu: false
    },
    PAGES: {
        visible: false,
        subMenu: false
    },
    ADMIN: {
        visible: false,
        subMenu: false
    },
    BLOG: {
        visible: false,
        subMenu: false
    },
    PHARMACY: {
        visible: false,
        subMenu: false
    },
    PATIENT: {
        visible: false,
        subMenu: false
    }
}
/**
 * Bug#502 
 * @Author: Linda Susan Raju 
 *  @Date: 19 Jul 2021
 */
const LOGIN_FB_GOOGLE = false;
const ENABLE_REMEMBER_ME = false;
/**End Bug#502 */

const ENABLE_FORGOT_PASSWORD = false;
const ENABLE_SIGNUP = false;
const ENABLE_FCM_WEB = false;

/**Bug#623: FileUpload @Author Linda Susan Raju @Date 07 Oct 2021*/
enum UploadFileArea {
    PROFILE_IMAGE = "UPLOAD_PROFILE",
    INSURANCE_CARD = "UPLOAD_INSURANCE",
}


export {
    Menu, LOGIN_FB_GOOGLE,
    ENABLE_FORGOT_PASSWORD,
    ENABLE_SIGNUP,
    UploadFileArea,
    ENABLE_REMEMBER_ME,
    ENABLE_FCM_WEB,
}
/* End CR 423 */